<template>
  <div>
    <div class="bg blue">
    </div>
    <div class="container-in checkout"  style=" align-items: center; display: flex; min-height: 100vh;">
      <div v-if="data != null && publicOrgPay != undefined" class="smart-wrap"  >
        <div class="sheet row"  id="smart-wrap" :style=" setStyle(total, 'one') +'display:block;  flex: none; float:left;'">
          <div class="col-md-6" style="padding:0; float:left;">
            <img :src="publicOrgPay.logoColor[0].url" :alt="publicOrgPay.logoColor[0].url" style="max-width: 250px; margin:0 0 30px 0;"> <br>
            <span style="font-weight: 700;">Order No.</span> &nbsp; 
            <span style="font-weight: 700; color:#ff1414;">{{data.friendlyId}}</span> <br>
            <span  v-if="total == 0" style="font-weight: 700; color:#ff1414;">Paid in Full</span>
            
            <br><br>
          </div>
          <div class="col-md-6" style="text-align:right; float:left;">
            <p style="font-weight: 700; font-size:16px;">{{publicOrgPay.address}}</p>            
            <p style="font-weight: 700; font-size:16px;">{{publicOrgPay.supportEmail}}</p>
            <p style="font-weight: 700; font-size:16px;"> {{formatData('phone', publicOrgPay.phone )}}</p>
            <br>
          </div>  
          <div class="col-md-12" style="float:left;">
            <h2 style="float:left;" >{{data['contact.salutation'].value+' '+data['contact.firstName'].value+' '+ data['contact.lastName'].value}}</h2>
            <p style="float:right;">{{emails[0]}}</p>
            <br>
            <p style="float:right;">{{ formatData('phone',phones[0] ) }}</p>


            <p class="infoItem" style="clear: both;" data-toggle="collapse" href="#infoItem" role="button" aria-expanded="false" aria-controls="infoItem">Details</p>
            <div v-if="dataUser != 'Not authorized'"  class="collapse" id="infoItem">
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>PK: </strong> {{data.PK}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>SK: </strong> {{data.SK}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Active: </strong> {{data.active}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Parent: </strong> {{data.parent}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Form: </strong> {{data.form}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Creted By </strong> {{data.createdBy}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Created At: </strong> {{data.createdAt}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Updated At: </strong> {{data.updatedAt}}</p>
              <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>GSP1PK1: </strong> {{data.GSP1PK1}}</p>
            </div>
            <br>
          </div>
          <div class="list-group col-md-12">
            <span class="list-group-item list-group-item-action" v-for="(item, index) in JSON.parse(data.QuoteProductList.value).data" :key="index" >
              <h5 style="padding:0 0 10px; 0">{{item['product.name']}}</h5>
              <div style="padding:0 0 10px; 0" :id="'description-'+item.SK+'-'+index"> {{ description(item, index) }}</div>
              <p> <strong>Price: </strong>  {{ ( parseInt(item['product.price'])).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}} </p>
              <p v-if="item['product.discount'] != '0'"> <strong>Discount: </strong>  {{ ( parseInt(item['product.discount'])).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}} </p>
            </span>
          </div>
            <br>
          <div class="col-md-12 element-wrap " >
            <table class="table table-repeatable" id="myTable" style="min-width: 100%" >  
              <tbody>
                <tr>
                  <td class="row" style="border:none;">
                    <span class="col-6" style="color: #787878; font-size: 16px; font-weight: 600;" >Sub Total</span> <span class="col-6" style="text-align:right; font-size: 16px;  " >{{ parseInt(JSON.parse(JSON.parse(data.QuoteProductList.value).totals.subTotal )).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}}</span>
                    <span v-if="JSON.parse(data.QuoteProductList.value).totals.discount != 0" class="col-6" style="color: #787878; font-size: 16px; font-weight: 600;" >Discount</span> <span v-if="JSON.parse(data.QuoteProductList.value).totals.discount != 0" class="col-6" style="text-align:right; font-size: 16px;  " >{{ ( parseInt(JSON.parse(data.QuoteProductList.value).totals.discount)).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="row">
                    <span class="col-6" style="color: #787878; font-size: 16px; font-weight: 700;" >Total</span> <span class="col-6" style="text-align:right; font-weight: 600; font-size: 16px;  " > {{( parseInt(JSON.parse(data.QuoteProductList.value).totals.total)).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}}</span>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
          <div class="element-wrap col-12" style="padding:10px 0;" >
            <h6 style="padding:10px 0;" >Payment Plan</h6>
            <table class="table table-repeatable" id="myTable" style="min-width: 100%" >  
              
              <thead>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
              </thead>
              <tbody>
                <tr v-for="(item, index) in payments" :key="index">
                  <td>
                    <span v-if="item['pay.dueDate'].value != 0">{{  setDate(item['pay.dueDate'].value) }} </span>
                    <span v-else>Down payment</span>
                    </td>
                  <td>{{( parseInt(item['pay.amount'].value)).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}}</td>
                  <td>
                    <svg v-if="item['pay.status'].value == 'Paid'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(2, 201, 42, 1);transform: ;msFilter:;"><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                    <svg v-if="item['pay.status'].value == 'error'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(251, 0, 4, 1);transform: ;msFilter:;"><path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path></svg>
                    <!--svg v-if="item.status == 'Pending'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 141, 251, 1);transform: ;msFilter:;"><path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"></path><path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path></!--svg-->
                  </td>
                </tr>
                <tr>
                  <td >
                    <span class="col-6" style="color: #787878; font-size: 16px; font-weight: 700;" >Total</span> 
                  </td>
                  <td > 
                    <span style="text-align:right; font-weight: 600; font-size: 16px;  " >{{( parseInt(JSON.parse(data.QuoteProductList.value).totals.total)).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}}</span>
                  </td>
                  <td >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <br><br>
        </div>
        <div class="sheet" v-show="$router.currentRoute.value.query.mode != 'r'" v-if="total != 0" :style=" setStyle(total, 'two') +'display:block; flex: none; float:left; '" >
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <a class="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="one" aria-selected="true">Credit Cards</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="one" role="tabpanel" aria-labelledby="one-tab">
              <br>
              <div v-if="publicOrgPay.paymentProcessor == 'Braintree'">
                <h6 v-if="methodPayment == 'Sandbox'" style="color:red;">{{methodPayment}}</h6>
                <div class="input-wrap">
                  <label for="Pay Today">Pay Today</label>
                    <h5>{{(parseInt(total)).toLocaleString('en-US', { style: 'currency', currency: 'USD'})}}</h5>
                  </div>
                <div class="demo-frame ">
                  
                  <form action="/" method="post"  id="cardForm" autocomplete="off">
                    <label class="hosted-fields--label" for="card-number">Card Number</label>
                    <div id="card-number" class="hosted-field"></div>

                    <label class="hosted-fields--label" for="expiration-date">Expiration Date</label>
                    <div id="expiration-date" class="hosted-field"></div>

                    <label class="hosted-fields--label" for="cvv">CVV</label>
                    <div id="cvv" class="hosted-field"></div>

                    <label class="hosted-fields--label" for="postal-code">Postal Code</label>
                    <div id="postal-code" class="hosted-field"></div>

                    <div class="button-container">
                    <br>
                    <div class="input-wrap col-12" style="text-align: left;">
                      <!--input type="checkbox" class="box" /-->
                      <!--span class="text" style="font-size:12px;display: block;float: right;width: calc(100% - 20px); padding: 0 0 0 10px;" > Save this CC for future transactions </span-->
                      <br>
                      <input type="checkbox" class="box" v-model="tandc"/>
                      <span class="text" style="font-size:12px;display: block;float: right;width: calc(100% - 20px); padding: 0 0 0 10px;" >I agree to the <a :href="publicOrgPay.termsAndConditions" target="_blank">terms and conditions</a></span>
                    </div>
                    <br>
                    <input v-if="tandc == true" type="submit" class="btn-g show green center" value="Pay" style="cursor:pointer;" id="submit" v-on:click="action()" />
                    <input v-else type="submit" class="btn-g show gray center" style="cursor:pointer;" value="Pay" disabled />
                    </div>
                  </form>
                </div>
              </div>
              <div v-else>
                Square
              </div>

            </div>
            <div class="tab-pane fade" id="two" role="tabpanel" aria-labelledby="two-tab">
              <ui-button :position="'center'" :text="'Pay Pal'" style="cursor: pointer;"  v-on:click="exportAs('pdf', data )" />
            </div>
            <div class="tab-pane fade" id="three" role="tabpanel" aria-labelledby="three-tab">
              <br>
              <ui-button id="venmo-button" :position="'center'" :text="''" :color="'venmo'" style="cursor: pointer;  height: 44px;" >
                <svg width="70" height="30" viewBox="0 0 53 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.70194 0C9.07294 0.590169 9.23028 1.1902 9.23028 1.95134C9.23028 4.38435 7.13181 7.54233 5.43416 9.77807H1.57013L0 0.530988L3.39863 0.197272L4.21847 6.77298C4.99525 5.54825 5.94263 3.59527 5.94263 2.2604C5.94263 1.542 5.80516 1.03567 5.60641 0.616472L8.70194 0ZM13.1175 4.05721C13.732 4.05721 15.3253 3.77445 15.3253 2.89331C15.3253 2.45767 15.0156 2.2341 14.6628 2.2341C14.0251 2.2341 13.2036 3.0051 13.1175 4.05721ZM13.0496 5.81292C13.0496 6.90942 13.6458 7.34506 14.4657 7.34506C15.3452 7.34506 16.1633 7.12313 17.2681 6.5757L16.8457 9.33914C16.0772 9.70738 14.8781 9.95726 13.7137 9.95726C10.7722 9.95726 9.71059 8.20154 9.71059 5.96581C9.71059 3.09058 11.4381 0.0410991 14.9725 0.0410991C16.9136 0.0410991 18.0183 1.11951 18.0183 2.63686C18.0183 5.04356 14.8599 5.81292 13.0496 5.83101V5.81292ZM27.8283 2.14697C27.8283 2.52343 27.7571 3.02976 27.7157 3.38156L26.6971 9.77807H23.3846L24.3171 3.90432L24.3767 3.24511C24.3767 2.80947 24.1183 2.72399 23.8069 2.72399C23.3581 2.72399 22.9192 2.92126 22.6608 3.04784L21.5992 9.77972H18.2867L19.7889 0.198915H22.6625L22.7039 0.968273C23.3862 0.532633 24.2922 0.026304 25.551 0.026304C27.2254 0.026304 27.83 0.900872 27.83 2.17656L27.8283 2.14697ZM37.6532 1.07842C38.6006 0.419201 39.4817 0.0246594 40.7404 0.0246594C42.4232 0.0246594 43.0178 0.899227 43.0178 2.17491C43.012 2.5799 42.9749 2.98385 42.9068 3.3832L41.8882 9.77972H38.5757L39.5231 3.79418L39.5761 3.31416C39.5761 2.83577 39.3094 2.72399 38.9716 2.72399C38.5757 2.72399 38.1617 2.89495 37.8668 3.04784L36.8151 9.77972H33.5026L34.4517 3.7761L34.4931 3.31416C34.4931 2.83577 34.2264 2.72399 33.8985 2.72399C33.448 2.72399 33.0356 2.92126 32.7407 3.04784L31.7056 9.76163H28.3782L29.8953 0.198915H32.7242L32.8368 0.994576C33.501 0.50633 34.3804 0.026304 35.5713 0.026304C36.6329 0.026304 37.2987 0.465232 37.6515 1.08006L37.6532 1.07842ZM49.5997 3.85994C49.5997 3.09058 49.401 2.54315 48.8229 2.54315C47.5046 2.54315 47.2379 4.84629 47.2379 6.01019C47.2379 6.90942 47.4781 7.45685 48.0743 7.45685C49.3066 7.45685 49.5997 5.04356 49.5997 3.85994V3.85994ZM43.8542 5.8721C43.8542 2.85221 45.4955 0.0246594 49.179 0.0246594C51.9814 0.0246594 53 1.66859 53 3.93063C53 6.90942 51.4117 10 47.6089 10C44.8049 10 43.8542 8.17689 43.8542 5.8721Z" fill="white"/>
                </svg>
              </ui-button>
            </div>
          </div>
          <br><br>
          <div id="paypal-button"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  let tokenQuote = null
  
  //Tools
  
  import { API, Storage, Auth} from 'aws-amplify'
  import Vuex from "vuex";
  import Swal from 'sweetalert2'
  import { formatData } from "../../store/tools";
  
  //import html2pdf from 'html2pdf'
  //Components
  import PaperDisplayer from '../../components/papers/PaperDisplayer.vue'
  import UiButton from '../../components/ui/UiButton.vue';
  //GRAPHQL
  import { smd_processPayment } from '../../graphql/mutations'
  import { smd_getRecordObj, smd_getPublicQuoteSet } from '../../graphql/queries'

  export default {
    name:'checkout',
    components:{
      PaperDisplayer,
      UiButton,
    },
    data() {
      return {
        data: null,
        total: 0,
        tandc: false,
        date: (new Date()).toISOString().split('T')[0],
        methodPayment: 'undefined',
        emails: [],
        phones: [],
      }
    },
    created() {
      this.setPublicOrganization(undefined)
      this.setPublicOrganizationData(undefined)
      this.setPublicOrgPay  (undefined)
      this.loading('show')
      this.setUserWeb()
      /*if (this.reload == true){
        this.setStatusReload(false);
        location.reload();
      }*/
      
    },
    methods: {
      ...Vuex.mapActions(['getPublicOrganization','getPublicOrganizationData']),
      ...Vuex.mapMutations(['setStatusReload','setPublicOrganizationData','setPublicOrgPay','setPublicOrganization','setContactSK']),
      //Tools
      formatData(format, data){
        return formatData(format, data)
      },
      loading(action){
        if (action == 'show') {
          document.getElementById("loading").classList.add('show')
          document.getElementById("body").classList.add("noScroll")
        }else{
          document.getElementById("loading").classList.remove('show')
          document.getElementById("body").classList.remove("noScroll")
        }
      },
      setDate(date) {
        //console.clear()
        let value = date
        try {
          let dateToday = new Date().toISOString().split("T")[0];
          if (date.split("-")[0] == dateToday.split("-")[0] ) {
            if (date.split("-")[1] == dateToday.split("-")[1]) {
              switch (parseInt(date.split("-")[2])) {
                case parseInt(dateToday.split("-")[2])+1:
                  value = 'Tomorrow'
                break;
                case parseInt(dateToday.split("-")[2]):
                  value = 'Today'
                break;
                case parseInt(dateToday.split("-")[2])-1:
                  value = 'Yesterday'
                break;
                default:
                  value = new Date(date).toLocaleDateString(navigator.language)
                break;
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
        return value;
      },
      setStyle(total, sheet){
        let value = ''
        if (total != 0 && this.$router.currentRoute.value.query.mode != 'r') {

          if (sheet == 'one') {
            value = 'width: calc(66.66% - 40px); margin:0 20px ;'
          } else {
            value = 'width: calc(33.33% - 40px); margin:0 20px ;'
          }
        } else {
          if (sheet == 'one') {
            value = 'width: calc(100% - 40px); margin:0 20px ;'
          } else {
            value = 'display: none; !important'
          }
        }
        if (screen.width < 767) {
          value = 'width: 100%!important; margin:0 0 20px 0; '
        }
        return value
      },
      formatPhone(data){
        console.clear()
        let value = data
        try {
          value = value.slice(0,2)+ '('+value.slice(2,5)+')' + value.slice(5,8)+'-'+value.slice(8)
        } catch (error) {
          console.log(error);
        }
        return value
      },
      //View
      async setUserWeb(){
      this.loading('show')
      try {
        await Auth.signIn('smd_webuser', '383@JDU45ss#')
      } catch (err) {
        console.log(err);
      }
      try {
        await this.getPublicOrganization()//Alias
        await this.getDataQuote();
        this.setPaymentMethods();
      } finally {
        this.loading('hidde')
      }
      },
      async action(){
        tokenQuote = null
        let waited = 0
        while (tokenQuote == null && waited < 10000) {
          await new Promise((resolve) => setTimeout(resolve, 100))
          waited += 100
        }
        this.token()
      },
      async getDataQuote(){
        let pullData = null
        if (this.publicOrganization == undefined || this.$router.currentRoute.value.query.data == undefined) {
          Swal.fire({
            icon: 'warning',
            title: 'We could not load this order',
            text: 'Please refresh the page. If the problem continues, contact support.',
          })
          return
        }
        try {
          pullData = await API.graphql({
            query : smd_getPublicQuoteSet,
            variables:{
              quotePK: this.publicOrganization,
              quoteSK: this.$router.currentRoute.value.query.data ,//data.SK
            }
          })
          pullData = pullData.data.smd_getPublicQuoteSet
          if (pullData.smd_response.statusCode != '200') {
            Swal.fire({
              icon: 'warning',
              title: pullData.smd_response.userMessage ,
              text: pullData.smd_response.message,
            })
          }else{
            this.data = JSON.parse(pullData.data).quote
            this.setContactSK  (this.data.GSP1PK1)
            this.total = JSON.parse(pullData.data).amount
            this.payments = JSON.parse(pullData.data).pays
            this.emails = JSON.parse(pullData.data).emails
            this.phones = JSON.parse(pullData.data).phones
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Something went wrong!' ,
            text: JSON.stringify(error),
            footer: 'getDataQuote(){smd_getPublicQuoteSet}'
          })
        }
      },
      async token(){
        let pushData = null
        let payload = null
        try {
          payload = JSON.parse(tokenQuote)
        } catch (error) {
          payload = null
        }
        if (payload == null || payload.token == null) {
          this.loading('hidden')
          Swal.fire({
            title: 'Transaction cannot be processed at this time.' ,
            text: 'Please review your information and try again. If the information is correct, please contact your bank'
          })
          return
        }
        try {
            this.loading('show')
            pushData = await API.graphql({
              query : smd_processPayment,
              variables:{
              orgPK: this.publicOrganization ,// data.PK,
              user: JSON.stringify( {
                PK: this.data.PK,
                SK: this.data.GSP1PK1
              }),
              cartItems: JSON.stringify({
                PK: this.publicOrganization ,// data.PK,
                SK: this.$router.currentRoute.value.query.data ,//data.SK
              }),
              link: window.location.href,
              totalCharge: this.total,
              paymentParameters: tokenQuote
              }
            })
            
            pushData = pushData.data.smd_processPayment
          if ( pushData.smd_response.statusCode == '200' ) {
            this.$router.push({ path: '/success', query: { data: this.$router.currentRoute.value.query.data } })
            this.loading('hidden')
          }else{
            this.loading('hidden')
            Swal.fire({
              icon: 'warning',
              title: 'status code : '  +pushData.smd_response.statusCode  ,
              text: pushData.smd_response.message,
              footer:pushData.smd_response.userMessage
            })
          }
        } catch (error) {
          this.loading('hidden')
          console.log(error);
          Swal.fire({
            icon: 'error',
            title: 'Something went wrong!' ,
            text: JSON.stringify(error),
            footer:'smd_processPayment'
          })
        }
      },
      description(item, index){
        setTimeout(() => {   
          let element = document.getElementById('description-'+item.SK+'-'+index)
          //console.log(element.innerHTML);
          element.innerHTML= unescape(item['product.description'])
        }, 100);
      },
      exportAs(as, data){
      let nameFile = data.entityName+'_#'+data.friendlyId+'_'+data.SK
      try {
        switch (as) {
          case 'pdf':
            var element = document.getElementById('smart-wrap');
            var opt = {
              margin: [9, 20],
              filename: nameFile.toLowerCase()+'.pdf',
            };
            html2pdf(element,opt); 
          break;
        }
      } catch (error) {
        console.log(error);
      }
      },
      setPaymentMethods(){
        let form = null
        if (this.total == 0 || this.$router.currentRoute.value.query.mode == 'r') {
          return
        }
        this.$nextTick(() => {
          let authorization = null;
          if (this.publicOrgPay == undefined) {
            console.error('setPaymentMethods: organization payment data not loaded');
            return
          }
          this.methodPayment = this.publicOrgPay.paymentMode;
          form = document.getElementById('cardForm')
          if (form == null) {
            return
          }
          if (this.publicOrgPay.paymentMode =='Sandbox') {
            authorization = this.publicOrgPay.sandboxClientsideToken
          } else {
            authorization = this.publicOrgPay.clientsideToken;
          }

          braintree.client.create({ authorization: authorization },
          function (err, clientInstance) {
            if (err) {
              console.error(err);
              return;
            }
            createHostedFields(clientInstance);
          });
        });
        function createHostedFields(clientInstance) {
          braintree.hostedFields.create({
            client: clientInstance,
            styles: {
              'input': {
                'font-size': '16px',
                'font-family': 'courier, monospace',
                'font-weight': 'lighter',
                'color': '#555555'
              },
              ':focus': {
                'color': 'black'
              },
              '.valid': {
                'color': '#08a414f7'
              }
            },
            fields: {
              number: {
                selector: '#card-number',
                //placeholder: '4111 1111 1111 1111'
              },
              cvv: {
                selector: '#cvv',
                //placeholder: '123'
              },
              expirationDate: {
                selector: '#expiration-date',
                placeholder: 'MM/YYYY'
              },
              postalCode: {
                selector: '#postal-code',
                //placeholder: '11111'
              }
            }
          }, function (err, hostedFieldsInstance) {
            if (err) {
              console.error(err);
              return;
            }
            var tokenize = function (event) {
              event.preventDefault();

              hostedFieldsInstance.tokenize(function (err, payload) {
                document.getElementById("loading").classList.remove('show')
                document.getElementById("body").classList.remove("noScroll")
                if (err) {
                  console.log(err);
                  tokenQuote = JSON.stringify({token:null, processorResponse:err })
                  return;
                }
                tokenQuote = JSON.stringify({token:payload.nonce, processorResponse:payload })
                //alert('Submit your nonce (' +  payload.nonce + ') to your server here!');
              });
            };

            form.addEventListener('submit', tokenize, false);
            //form.on("submit", tokenize, false);
          });
        }
      },
    },
    computed:{
      ...Vuex.mapState(['publicOrganization', 'publicOrganizationData', 'reload', 'user','publicOrgPay','dataUser'])
    }
  }
</script>